import React, { useEffect } from 'react'
import ZooLogin from './ZooLogin'
import { useData } from './graphql/useData'
import { useApolloClient } from '@apollo/client'
import { useAuthentication } from 'providers/Authentication'
import { useRouter } from 'next/router'
import { useModalState } from 'components/ModalProvider/index.state'
import { Button, Nzk } from 'nzk-react-components'
import styled from 'styled-components'
import NotAChildModal from './components/NotAChildModal'

const Header = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  z-index: 1;
  padding: 5px 15px;
  align-items: center;
`

const LoginPage = () => {
  const data = useData()
  const client = useApolloClient()
  const router = useRouter()
  const modal = useModalState()
  const { login, isLoggedIn } = useAuthentication()

  useEffect(() => {
    if (isLoggedIn) {
      const params = new URLSearchParams(location.search)
      const redirectTo = params.get('redirectTo') || '/zoo/map'
      router.replace(redirectTo)
    }
  }, [isLoggedIn])

  const onNotAChild = () => {
    modal.open(<NotAChildModal />, 'not-a-child-modal')
  }

  return (
    <>
      <Header>
        <div>
          <a href="https://www.nightzookeeper.com">
            <Nzk height={60} width={60} />
          </a>
        </div>
        <div>
          <Button size='small' theme='primary' onClick={onNotAChild}>Not a child?</Button>
        </div>
      </Header>
      <ZooLogin {...data} client={client} login={login} router={router} isLoggedIn={isLoggedIn} />
    </>
  )
}

LoginPage.getLayout = (page: any) => {
  return <>{page}</>
}

export default LoginPage
